module.exports = __webpack_public_path__ + "media/connectivity-hero.b72cfa7d.mp4";